import { AppSettings } from '../app.settings';
import { OtherScreenFiltersDataModel } from './other-screen-filters-data-model';

export class OtherScreenFilter {
    screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
    /** Filters are saved per user + screen + event; the backend rejects a save without it. */
    eventId?: String;
    filterData: OtherScreenFiltersDataModel = new OtherScreenFiltersDataModel();
  
    constructor(options?: {
      screenCode?: String,
      eventId?: String,
      filterData: OtherScreenFiltersDataModel
    }) {
      if (options) {
        this.screenCode = options.screenCode;
        this.eventId = options.eventId;
        this.filterData = options.filterData;
      }
    }
}
